/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Locations API
 * AV Services Locations management API
 * OpenAPI spec version: 1.0
 */

export interface ClientUserSettings {
  /** User session timeout in minutes */
  userSessionTimeoutMinutes: number;
}
